module.exports = __webpack_public_path__ + "static/media/icon-close--med-gray.47aa3136.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/imgs/icon-close--med-gray.svg
// module id = 288
// module chunks = 0